import React from 'react';
import { Size } from '../../../../Enums/Size.enum';
import Modal from '../../../../Components/Modal/Modal';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import SUKLCredentialsHint from './SUKLCredentialsHint';

interface Props {
	onClose: () => void;
	onConfirm: () => void;
}

const SUKLCredentialsHintModal: React.FC<Props> = ({ onConfirm, onClose }) => {
	const { isCase } = useTreatmentContext();

	return (
		<Modal opened onClose={onClose} wrapChat={isCase} size={Size.MD}>
			<Modal.Header title='component.userSuklLoginCredentials.title' />
			<Modal.Content>
				<SUKLCredentialsHint onConfirm={onConfirm} />
			</Modal.Content>
		</Modal>
	);
};

export default SUKLCredentialsHintModal;
